interface Props {
  color?: string
  width?: number
  height?: number
}

export const AlignTextCenterIcon = ({ color = '#6F6F6F', width = 24, height = 24 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M18 9.5H6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 4.5H3" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 14.5H3" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 19.5H6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
